import { DatabaseData, SearchResult } from '../types/database'

export const searchInDatabase = (
  databaseData: DatabaseData,
  query: string,
  options: {
    caseSensitive?: boolean
    matchType?: 'exact' | 'partial' | 'regex'
  } = {}
): SearchResult[] => {
  const { caseSensitive = false, matchType = 'partial' } = options
  const results: SearchResult[] = []
  
  if (!query.trim()) return results

  const searchQuery = caseSensitive ? query : query.toLowerCase()

  for (const [tableName, table] of Object.entries(databaseData.tables)) {
    for (let rowIndex = 0; rowIndex < table.rows.length; rowIndex++) {
      const row = table.rows[rowIndex]
      
      for (const column of table.columns) {
        const value = row[column.name]
        if (value === null || value === undefined) continue
        
        const stringValue = String(value)
        const searchValue = caseSensitive ? stringValue : stringValue.toLowerCase()
        
        let isMatch = false
        
        switch (matchType) {
          case 'exact':
            isMatch = searchValue === searchQuery
            break
          case 'partial':
            isMatch = searchValue.includes(searchQuery)
            break
          case 'regex':
            try {
              const regex = new RegExp(searchQuery, caseSensitive ? 'g' : 'gi')
              isMatch = regex.test(searchValue)
            } catch {
              // 無効な正規表現の場合は部分一致で検索
              isMatch = searchValue.includes(searchQuery)
            }
            break
        }
        
        if (isMatch) {
          results.push({
            tableName,
            rowIndex,
            columnName: column.name,
            value,
            matchType
          })
        }
      }
    }
  }
  
  return results
}

export const highlightSearchResult = (
  text: string,
  query: string,
  caseSensitive: boolean = false
): string => {
  if (!query.trim()) return text
  
  const searchQuery = caseSensitive ? query : query.toLowerCase()
  const searchText = caseSensitive ? text : text.toLowerCase()
  
  if (!searchText.includes(searchQuery)) return text
  
  const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, caseSensitive ? 'g' : 'gi')
  return text.replace(regex, '<mark class="bg-yellow-200 px-1 rounded">$1</mark>')
}

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout
  
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func(...args), delay)
  }
} 